import { ImageCell } from '@/components/shared/ImageCell';
import type { PromotionalOffer } from '@/config/objects/promotional-offers';

interface PromotionalOfferImageCellProps {
  offer?: PromotionalOffer;
  size?: 'sm' | 'lg';
}

/**
 * Editable promotional offer image cell component with upload and delete actions
 */
export function PromotionalOfferImageCell({
  offer,
  size = 'sm',
}: PromotionalOfferImageCellProps) {
  return (
    <ImageCell
      item={offer}
      endpoint="/promotional-offers"
      entityName="Promotional Offer"
      imageLabel="Offer Image"
      getFeaturedImage={(item) => item.featuredImage}
      getItemId={(item) => item.id}
      size={size}
    />
  );
}
